<template>
  <el-select :disabled="disabled" filterable :clearable='clearable' @change="handleChange" :value="data.value" placeholder="请选择"
             @clear="handleChange">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in ProductHardware" :key="index"></el-option>
  </el-select>
</template>

<script>
    
    import { getProductModle,getProductHardware,getProductSoftware} from "@/services/product";
    // import { findTypeList } from "@/services/deviceOrder";

    export default {
        name: 'Hardware',
        props: {
            value: {},
            
            disabled: {
                type: Boolean,
                default: false
            },
            clearable:{
                type: Boolean,
                default: true
            }
        },

        data() {
            return {data: {}, ProductHardware: []}
        },
        watch: {
            value:{
                immediate:true,
                handler(value){
                    if (value) {
                            this.data = value;
                        } else {
                            this.data = {};
                        }

                }
            },
           
        },
        mounted() {
            this.loadData();
        },
        methods: {
           
            handleChange(value) {
                
                let find = this.ProductHardware.find((item, i) => {
                    return item.value == value
                })
                if (!find) {
                    find = {};
                }
               
                if (find==undefined) {
                    find = "";
                }
                this.$emit("input", {...find});
                this.$emit("change", {...find});
                this.data = {...find};
            },
            async loadData() {
               
                const res2 =await  getProductHardware({type:2,page:1,size:999})
                if(res2&&res2.code==0){
                     this.ProductHardware =res2.data.list.map((item, i) => {
                        return {name: item.editionName, value: item.editionName}
                    })
                 
                }
              
               
              
            }

        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/operation/hardwar.vue